import { useQuery } from 'react-query';

import Api from '../../api/api';

export type AllTopics = {
  page?: number;
  limit?: number;
  sort?: string;
  search?: string;
  published?: boolean;
  suggested?: boolean;
};

const getAllTopics = async (params: AllTopics) => {
  const [response, bodyOrError] = await Api.get(`topics`, params);

  if (!response?.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

const useGetAllTopics = (params: AllTopics) => {
  return useQuery({
    queryKey: ['topics', params],
    queryFn: () => getAllTopics(params),
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
};

export default useGetAllTopics;
